import { createSportsnewPlacementAttemptOwner } from './sportsnewPlacementAttemptOwner.js';

export const createSportsnewPlacementAttemptRuntime = ({
  owner = createSportsnewPlacementAttemptOwner(),
} = {}) => {
  const flights = new Map();

  return Object.freeze({
    acquire: input => owner.acquire(input),
    list: userId => owner.list(userId),
    current: (userId, identity) => owner.current(userId, identity),
    authorizeContinuation: (idempotencyKey, userId, challenge) => (
      owner.authorizeContinuation(idempotencyKey, userId, challenge)
    ),
    recordReceipt: (idempotencyKey, receipt, userId, challenge, accountGeneration) => (
      owner.recordReceipt(idempotencyKey, receipt, userId, challenge, accountGeneration)
    ),
    recordReceiptIssueFailure: (idempotencyKey, response, options, userId, challenge) => (
      owner.recordReceiptIssueFailure(idempotencyKey, response, options, userId, challenge)
    ),
    recordResponse: (idempotencyKey, response, options, userId, challenge) => (
      owner.recordResponse(idempotencyKey, response, options, userId, challenge)
    ),
    markUnknown: (idempotencyKey, userId, challenge) => (
      owner.markUnknown(idempotencyKey, userId, challenge)
    ),
    retire: (idempotencyKey, userId, challenge) => owner.retire(idempotencyKey, userId, challenge),
    runSingleFlight({ idempotencyKey, phase }, work) {
      const flightKey = `${idempotencyKey}:${phase}`;
      const existing = flights.get(flightKey);
      if (existing) return existing;
      const running = Promise.resolve().then(work);
      flights.set(flightKey, running);
      running.finally(() => {
        if (flights.get(flightKey) === running) flights.delete(flightKey);
      }).catch(() => {});
      return running;
    },
  });
};

export const sportsnewPlacementAttemptRuntime = createSportsnewPlacementAttemptRuntime();
